<a class="logo-container" [routerLink]="dashboardRoute">
  <img class="logo"
    [class.default-logo]="isDefaultLogo"
    [class.is-order-central]="isOrderCentral"
    [src]="logoUrl">
  <img class="smaller-logo"
    [class.is-order-central]="isOrderCentral"
    src="assets/sps-logo.svg">
  </a>
  @if (title) {
    <span class="title-sep">|</span>
    <span class="title">{{title}}</span>
  }
